import React, { useEffect, useState } from 'react';
import styles from '../../styles/AutoDocumentService/GovtLetter.module.css';
import logo1 from '../../assets/image/top-left.png';
const DocZone = ({ name, address, date, proposalId, survey, zoneStatement, signPath }) => {
    const [SignaturePath, setSignaturePath] = useState(null);
    //const token = localStorage.getItem("token_office");
    useEffect(() => {
        const fetchOfficeProfile = async () => {
            setSignaturePath(signPath);
         
        };

        fetchOfficeProfile();
    }, []);


    const [signBase64, setSignBase64] = useState(null);

    useEffect(() => {
        const loadSignature = async () => {
            if (SignaturePath) {
                const base64Img = await toBase64(`${process.env.REACT_APP_SERVER_URL}/proxy_image.php?path=${SignaturePath}`);
                setSignBase64(base64Img);
            }
        };
        loadSignature();
    }, [SignaturePath]);

    const toBase64 = async (url) => {
        const res = await fetch(url);
        const blob = await res.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    };


    return (
        <>
            <div className={styles.letterContainer}>
                {/* Top Logo */}
                <div className={styles.logo}>
                    <img src={logo1} alt="Government Logo" className={styles.logoImage} />
                </div>

                {/* Department Header */}
                <div className={styles.headerText}>
                    <div>महाराष्ट्र शासन</div>
                    <div>नगर रचना आणि मूल्यनिर्धारण विभाग,</div>
                    <div>सांगली मिरज आणि कुपवाङ शहर महानगरपालिका</div>
                    <div>शहर पोलीस ठाण्यासमोर, राजवाडा चौक. सांगली, महाराष्ट्र - ४१६ ४१६.</div>
                </div>

                {/* Email and Contact */}
                <div className={styles.contactRow}>
                    <div className={styles.email}>Email ID : smkcorporation@gmail.com</div>
                    <div className={styles.phone}>दुरध्वनी क्र. 0233-2373721</div>
                </div>

                <hr className={styles.divider} />

                {/* Reference and Date */}
                <div className={styles.refDateRow}>
                    {/* <div>जा.क्र. मनपा/टिभी/७/९/सन/ ७३७/२०१५-१६</div> */}
                     <div></div>

                    <div>दि. {date}</div>
                </div>

                {/* Recipient */}
                <div className={styles.sectionRecipient}>
                    <strong>प्रति,</strong><br />
                    <div>
                        &nbsp; &nbsp; Shri/Smt. {name},<br />
                        &nbsp; &nbsp; {address}
                    </div>
                </div>

                {/* Subject and Reference */}
                <div className={styles.section}>

                    <strong>विषयः-</strong> सागली मिरज आणि कुपवाड शहर महानगरपालिका क्षेत्राच्या महाराष्ट्र प्रादेशिक व नगररचना अधिनियम १९६६ चे कलम ३१ (१) अन्वये शासनाने मंजूर केलेल्या विकास योजनेच्या अभिप्रयाबाबत.<br />
                    <strong>संदर्भः-</strong> आपला दि.${date} रोजीचा Online अर्ज. (Proposal ID : ${proposalId})
                </div>

                {/* Letter Body */}
                <div className={styles.bodyText}>
                    महाशय,<br />
                    &nbsp; &nbsp; &nbsp; &nbsp; सांगली मिरज आणि कुपवाड शहर महानगरपालिका क्षेत्राची प्रारूप विकास योजना शासनाने कलम ३१ (१) खाली अधिसूचना क्रमांक TPS-२००८/२४४/CR-१८१४/०९/D.P/Sanction/UD-१३ दि. ४ एप्रिल २०१२ अन्वये भागशः मंजूर केलेली आहे व भागशाः दि. ०३/०३/२०१६ रोजी मंजुरी दिलेली आहे. अधिसूचना अहवाल नुसार सांगली / सामलीवाडी येथील भूमापन क्रमांक / नगर भूमापन क्रमांक १३३ जुना या जागेबाबतचे अभिप्राय खालीलप्रमाणे आहेत. <b>{zoneStatement}</b> <br /> <br />
                    १. प्या दाखल्याचा वापर पोट विभागणी, बिनशेती कामे वापर करण्यासाठी नाही . <br />
                    २. सांमि कु मनपा हद्दीसाठी ची कलम ३१ (१) अन्वये शासन मंजूर विकास योजनेचे नकाशे अद्याप महानगरपालिकेस प्राप्त झालेले नाहीत. असे नकाशे प्राप्त झालेनंतर मंजूर विकास योजनेचे अभिप्राय अधिक स्पष्ट्यणे देता येतील.

                </div>


                {/* Footer */}
                <div className={styles.footer}>

                    <div style={{ textAlign: "right" }}>
                        {signBase64 ? (
                            <img
                                src={signBase64}
                                alt="Signature"
                                style={{ maxWidth: "150px", marginBottom: "1px" }}
                            />
                        ) : (
                            <p>No signature uploaded</p>
                        )}
                    </div>
                    <p className={styles.signature}>

                        शाखा अभियंता<br />
                        सांगली मिरज आणि कुपवाड शहर महानगरपालिका
                    </p>
                </div>
            </div>

        </>
    );
};

export default DocZone;